import { render, staticRenderFns } from "./Opentp.vue?vue&type=template&id=6e49bd6f"
import script from "./Opentp.vue?vue&type=script&lang=js"
export * from "./Opentp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports